import { useEffect, useState } from "react";
import { getInvoice } from "../api/invoices";
import { useParams, Link } from "react-router-dom";

export default function InvoiceDetails() {
    const { id } = useParams();
    const [inv, setInv] = useState(null);
    const [err, setErr] = useState("");

    const statusColor = {
        Pending: "text-yellow-600",
        Paid: "text-green-600",
        Cancelled: "text-red-600",
    };

    useEffect(() => {
        if (!id) {
            setErr("Invoice ID is missing");
            return;
        }

        (async () => {
            try {
                setInv(await getInvoice(Number(id)));
            } catch (e) {
                setErr(e.message || "Load error");
            }
        })();
    }, [id]);

    if (err) return <p className="text-red-500">{err}</p>;
    if (!inv) return <p>Loading…</p>;

    return (
        <div className="max-w-xl mx-auto p-6">
            <Link className="text-blue-600" to="/invoices">
                ← Back
            </Link>

            <h1 className="text-xl font-bold mt-2 mb-4">
                Invoice {inv.number}
            </h1>

            <div className="space-y-2">
                <p><b>Amount:</b> {inv.amount} {inv.currency}</p>

                <p>
                    <b>Status:</b>{" "}
                    <span className={statusColor[inv.status] || ""}>
                        {inv.status}
                    </span>
                </p>

                <p>
                    <b>Due:</b>{" "}
                    {inv.dueDate
                        ? new Date(inv.dueDate).toLocaleString()
                        : "—"}
                </p>

                {inv.description && (
                    <p><b>Description:</b> {inv.description}</p>
                )}
            </div>
        </div>
    );
}